export const headlessVersion = '3.27.5';
export const atomicVersion = '3.30.0';
